
const Apiurl = 'https://manageremail.enjoytool.net/backend';
export default Apiurl
